module.exports = __webpack_public_path__ + "img/qifei.b0f5cf94.png";